import type { ReactNode } from 'react';

export const symbol_mobile_hand_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M740-140v-261 47-466 680ZM313-40h-43q-63 0-106.5-43.5T120-190v-330q0-63 44.65-106.5T272-670h70v371l138-56q21-8 43-5.5t38 18.5l11 12q8.46 8.12 9.23 19.56Q582-299 574-290L394-76q-15 18-36.5 27T313-40Zm427-40H398l50-60h292v-680H342v150h-60v-150q0-24.75 17.63-42.38Q317.25-880 342-880h398q24.75 0 42.38 17.62Q800-844.75 800-820v680q0 24.75-17.62 42.37Q764.75-80 740-80ZM562.5-688.68q8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5 12.82 0 21.32-8.68ZM312-100q11 0 21.5-4.5T351-118l152-183-179 81q-15 7-28.5-1.75T282-248v-362h-12q-38 0-64 26t-26 64v330q0 37 26 63.5t64 26.5h42Z"
		/>
	</svg>
);
